import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

class NavButton extends Component {

    idleHand() {
        let navClass = "fadediv";
        if (this.props.idle === false) {
        navClass += " fadeout"
        }
        else {
        navClass += " jiggleitem"
        }
        return <div className={navClass} style={{ display: 'inline-block', height: '7vh' }}><img alt="interact" style={{ height: '7vh' }} src="/img/ui/handicon-02.png" /></div>
    }

    render() {

        if (this.props.showNav===false){
            return(
                <span />
            )
        }

        let navButtonStyle;
        if (this.props.screen.orientation==="horizontal"){
            navButtonStyle = {
                color: 'white',
                position: 'fixed',
                height: this.props.screen.screenHeight * .065,
                width: this.props.screen.screenHeight * .065,
                fontSize: this.props.screen.screenHeight * .025,
                left: this.props.screen.r16_9.left + this.props.screen.r16_9.p10,
                bottom: this.props.screen.r16_9.p10,
                zIndex: 99
            }
        }
        else {
            navButtonStyle = {
                color: 'white',
                position: 'fixed',
                height: this.props.screen.screenHeight * .065,
                width: this.props.screen.screenHeight * .065,
                fontSize: this.props.screen.screenHeight * .025,
                left: this.props.screen.r16_9.p10,
                bottom: this.props.screen.r16_9.p10,
                zIndex: 99
            }
        }

        let navClass = "fadediv";
        if (this.props.idle === true) {
            navClass += " fadeout"
        }
        if (this.props.animate === true && this.props.idle === false && this.props.recentInteraction === false) {
          navClass += " jiggleitem";
        }

        let idleHand = this.idleHand();


        return (
            <span className="phand " onMouseDown={this.props.handleNavigationSlide} style={navButtonStyle}>
                <span style={{ position: 'absolute', bottom: 0 }} >
                    <span className={navClass}>
                        <FontAwesome name='bars' size='2x' />
                    </span>
                </span>
                <span style={{ position: 'absolute', bottom: 0 }} >
                    {idleHand}
                </span>
            </span>
        )

    }
}

export default NavButton;



// WEBPACK FOOTER //
// ./src/containers/NavButton.js